import {
	getSourceAppFromUrl,
	getSourceUrlCandidatesFromText,
	isValidSourceUrl,
	MAX_AI_MANAGED_OBJECT_SOURCES,
} from './configuration';
import type { AiManagedObjectSourceEntry } from './types';

export const getNextSourceEntries = (
	currentEntries: AiManagedObjectSourceEntry[],
	rawSourceUrls: string,
): {
	entries: AiManagedObjectSourceEntry[];
	limitExceeded: boolean;
} => {
	const candidates = getSourceUrlCandidatesFromText(rawSourceUrls);
	const seenUrls = new Set(currentEntries.map((source) => source.url));
	const entries = [...currentEntries];
	let limitExceeded = false;

	candidates.forEach((candidate) => {
		if (seenUrls.has(candidate)) {
			return;
		}

		if (entries.length >= MAX_AI_MANAGED_OBJECT_SOURCES) {
			limitExceeded = true;
			return;
		}

		seenUrls.add(candidate);
		entries.push(
			isValidSourceUrl(candidate)
				? {
						app: getSourceAppFromUrl(candidate),
						status: 'resolving',
						url: candidate,
					}
				: {
						invalidReason: 'invalid-url',
						status: 'invalid',
						url: candidate,
					},
		);
	});

	return { entries, limitExceeded };
};

export const replaceSourceEntry = (
	sourceEntries: AiManagedObjectSourceEntry[],
	url: string,
	update: Omit<AiManagedObjectSourceEntry, 'url'>,
): AiManagedObjectSourceEntry[] =>
	sourceEntries.map((source) =>
		source.url === url
			? {
					...source,
					...update,
					url,
				}
			: source,
	);

export const removeSourceEntry = (
	sourceEntries: AiManagedObjectSourceEntry[],
	sourceUrl: string,
): AiManagedObjectSourceEntry[] => sourceEntries.filter((source) => source.url !== sourceUrl);
